import ValidityInfoText from './validity_info_text';

export default ValidityInfoText;
